import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as React from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import throttle from 'lodash/throttle';

function getGap(gutter, width) {
  var xs = gutter.xs,
      sm = gutter.sm,
      md = gutter.md,
      lg = gutter.lg,
      xl = gutter.xl;
  var gap = 0;
  if (xs && width > 0) gap = xs;
  if (sm && width >= 600) gap = sm;
  if (md && width >= 1024) gap = md;
  if (lg && width >= 1280) gap = lg;
  if (xl && width >= 1920) gap = xl;
  return gap;
}

var Row = function Row(props) {
  var _context;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _getCompProps = getCompProps('Row', userDefaultProps, props),
      style = _getCompProps.style,
      className = _getCompProps.className,
      children = _getCompProps.children,
      wrap = _getCompProps.wrap,
      gutter = _getCompProps.gutter,
      align = _getCompProps.align,
      justify = _getCompProps.justify,
      customPrefixcls = _getCompProps.prefixCls; // className前缀


  var prefixCls = getPrefixCls(pkgPrefixCls, 'row', customPrefixcls);

  var _React$useState = React.useState(window.innerWidth),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      winWidth = _React$useState2[0],
      setWinWidth = _React$useState2[1];

  var updateWidth = throttle(function () {
    return setWinWidth(window.innerWidth);
  }, 500);
  window.addEventListener('resize', updateWidth);
  var gap = {
    h: 0,
    v: 0
  };
  if (gutter.constructor === Number) gap.h = gutter;

  if (gutter.constructor === Object) {
    gap.h = getGap(gutter, winWidth);
  }

  if (Array.isArray(gutter)) {
    if (gutter[0].constructor === Object) {
      gap.h = getGap(gutter[0], winWidth);
    } else {
      gap.h = gutter[0];
    }

    if (gutter[1].constructor === Object) {
      gap.v = getGap(gutter[1], winWidth);
    } else {
      gap.v = gutter[1];
    }
  }

  var rowStyle = {
    '--cgap': "".concat(gap.h, "px")
  };
  if (gap.v) rowStyle['--rgap'] = "".concat(gap.v, "px");
  var toalign = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end'
  };
  var tojustify = {
    start: 'flex-start',
    end: 'flex-end'
  };

  var styleString = _extends(_extends(_extends({}, style), rowStyle), {
    alignItems: toalign[align] || align,
    justifyContent: tojustify[justify] || justify
  });

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, className, {
      nowrap: !wrap
    }),
    style: styleString
  }, _mapInstanceProperty(_context = React.Children).call(_context, children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      winWidth: winWidth
    });
  }));
};

Row.displayName = 'Row';
export default Row;